<div class="section">
    <div class="container">
        <div class="row">
            <div class="col-md-11 col-sm-11 ml-auto mr-auto mb-3">

                <h4 class="title">
                    <small></small>
                </h4>
                <span class="collapsed d-flex align-items-center justify-content-center">




                </span>

                <div class="row align-items-center justify-content-center">
                    <div class="col-3 align-items-center justify-content-center text-center">

                        <span><span class="statusindi online"></span><span>Online</span></span> 

                    </div>
                    <div class="col-3 align-items-center justify-content-center">

                        <span class="statusindi comment"></span><span>Problem</span>

                    </div>
                    <div class="col-3 align-items-center justify-content-center">

                        <span class="statusindi slow"></span><span class="mb-2">Delayed</span>

                    </div>
                    <div class="col-3 align-items-center justify-content-center">

                        <span class="statusindi offline"></span><span>Offline</span>

                    </div>


                </div>

                <!-- <div class="table-responsive">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th class="text-center">System</th>

                                <th>Subsystem</th>
                                <th>Status</th>
                                <th>Comment</th>

                            </tr>
                        </thead>
                        <tbody>
                     
                                <tr *ngFor="let row of Data">
                                    <td class="text-center">{{row.name}}</td>

                                    <td>



                                    </td>
                                    <td><span class="status {{row.status}}"></span> </td>
                                    <td>{{row.comment}}</td>

                                </tr>

                          
                        </tbody>
                    </table>
                
                </div> -->
                <h4 class="title mt-5">
                    <small>Notifications</small>
                </h4>
                <div class="" *ngFor="let notification of notificationData">

                    <ngb-accordion #acc="ngbAccordion">
                        <ngb-panel>
                            <ng-template ngbPanelTitle>
                                <div class="mb-0 panel-title">

                                    <span class="collapsed">

                                        <div class="row">
                                            <div class="col d-flex mr-auto text-{{notification.category}}">
                                                <span> {{ notification.created | date: 'd MMMM yyyy' }} -
                                                    {{notification.title}}</span>
                                            </div>
                                            <div class="col">
                                                <i class="nc-icon nc-minimal-down ml-auto"></i>
                                            </div>

                                        </div>

                                    </span>



                                </div>
                            </ng-template>
                            <ng-template ngbPanelContent>

                                <h6>
                                    <strong> Notes:</strong>
                                </h6>
                                <p class="ms-3">
                                    {{notification.detail}}
                                </p>


                            </ng-template>
                        </ngb-panel>
                    </ngb-accordion>

                </div>

                <h4 class="title mt-5">
                    <small>eMD Systems Status</small>
                </h4>
                <div id="tooltip" display="none" style="position: absolute; display: none; z-index: 5"></div>
                <div class="" *ngFor="let system of Data">

                    <ngb-accordion #acc="ngbAccordion">
                        <ngb-panel>
                            <ng-template ngbPanelTitle>
                                <div class="mb-0 panel-title">





                                    <span class="collapsed">

                                        <div class="row">
                                            <div class="col d-flex col-3 mr-auto text-dark">
                                                <span>{{system.name}}</span>
                                            </div>
                                            <div class="col float-right d-flex ">
                                                <span class="status {{system.status}}"></span>
                                            </div>





                                            <div class="col">
                                                <i class="nc-icon nc-minimal-down ml-auto"></i>
                                            </div>



                                        </div>
                                        <div class="row">

                                            <div class="col" style="margin-left: 40px;">

                                                <div class="row ms-10" style="vertical-align: middle">

                                                    <i *ngFor="let system_statistics of system.daily_statitics">
                                                        <svg *ngIf="system_statistics.status == 'normal'" class=""
                                                            id="uptime-component-nx5nxpmmhdmj"
                                                            preserveAspectRatio="none" height="34" viewBox="0 0 10 34">

                                                            <rect height="34" width="4" x="0" y="0" fill="#ffffff"
                                                                data-date="system_statistics.incident_date"
                                                                data-eventtext="system_statistics.detail" role="tab"
                                                                (mouseenter)="showTooltip($event, system_statistics)"
                                                                (mouseleave)="hideTooltip()"></rect>

                                                            <rect height="34" width="6" x="0" y="0" fill="#51bcda"
                                                                role="tab"
                                                                (mouseenter)="showTooltip($event, system_statistics)"
                                                                (mouseleave)="hideTooltip()"></rect>



                                                        </svg>



                                                        <svg *ngIf="system_statistics.status != 'normal'" class=""
                                                            id="uptime-component-nx5nxpmmhdmj"
                                                            preserveAspectRatio="none" height="34" viewBox="0 0 10 34">
                                                            <rect height="34" width="4" x="0" y="0" fill="#ffffff"
                                                                data-date="system_statistics.incident_date"
                                                                data-eventtext="system_statistics.detail" role="tab"
                                                                (mouseenter)="showTooltip($event, system_statistics)"
                                                                (mouseleave)="hideTooltip()"></rect>

                                                            <rect *ngIf="system_statistics.status != 'normal'"
                                                                height="34" width="6" x="0" y="0" fill="#ff0000"
                                                                data-date="system_statistics.incident_date"
                                                                data-eventtext="system_statistics.detail" role="tab"
                                                                (mouseenter)="showTooltip($event, system_statistics)"
                                                                (mouseleave)="hideTooltip()"></rect>

                                                        </svg>


                                                    </i>
                                                </div>
                                            </div>


                                        </div>
                                        <div class="row w-100 mt-2">
                                            <div class="col">
                                                <div class="container-indi">
                                                    <span class="text-indi">90 days ago</span><span
                                                        class="line-indi"></span>
                                                    <span class="text-indi">Uptime</span><span class="line-indi"></span>
                                                    <span class="text-indi">Today </span>
                                                </div>

                                            </div>
                                        </div>



                                    </span>



                                </div>
                            </ng-template>
                            <ng-template ngbPanelContent>

                                <h6>
                                    <strong> Notes:</strong>
                                </h6>
                                <p class="ms-3">
                                    {{system.comment}}
                                </p>



                                <div class="mt-3" *ngIf="system.subsystem.length != 0">
                                    <h6>
                                        <strong> Subsystems:</strong>
                                    </h6>
                                    <div *ngFor="let system_subsystem of system.subsystem">


                                        <div class="row">

                                            <div class="col">

                                                {{system_subsystem.name}}

                                            </div>
                                            <div class="col">

                                                <span class="status {{system_subsystem.status}}"></span>

                                            </div>


                                        </div>


                                        <div class="row">
                                            <div class="col" style="margin-left: 40px;">

                                                <div class="row ms-10" style="vertical-align: middle">
                                                    <i
                                                        *ngFor="let sub_system_statistics of system_subsystem.daily_statitics">
                                                        <svg *ngIf="sub_system_statistics.status == 'normal'" class=""
                                                            id="uptime-component-nx5nxpmmhdmj"
                                                            preserveAspectRatio="none" height="24" viewBox="0 0 10 24">

                                                            <rect height="24" width="4" x="0" y="0" fill="#ffffff"
                                                                role="tab" class=""
                                                                (mouseenter)="showTooltip($event, sub_system_statistics)"
                                                                (mouseleave)="hideTooltip()"></rect>

                                                            <rect height="24" width="6" x="0" y="0" fill="#51bcda"
                                                                role="tab" class=""
                                                                (mouseenter)="showTooltip($event, sub_system_statistics)"
                                                                (mouseleave)="hideTooltip()"></rect>



                                                        </svg>


                                                        <svg *ngIf="sub_system_statistics.status != 'normal'" class=""
                                                            id="uptime-component-nx5nxpmmhdmj"
                                                            preserveAspectRatio="none" height="24" viewBox="0 0 10 24">
                                                            <rect height="24" width="4" x="0" y="0" fill="#ffffff"
                                                                role="tab" class=""
                                                                (mouseenter)="showTooltip($event, sub_system_statistics)"
                                                                (mouseleave)="hideTooltip()"></rect>

                                                            <rect *ngIf="sub_system_statistics.status != 'normal'"
                                                                height="24" width="6" x="0" y="0" fill="#ff0000"
                                                                role="tab" class=""
                                                                (mouseenter)="showTooltip($event, sub_system_statistics)"
                                                                (mouseleave)="hideTooltip()"></rect>

                                                        </svg>


                                                    </i>
                                                </div>
                                            </div>


                                        </div>
                                        <div class="row w-100 mt-2">
                                            <div class="col">
                                                <div class="container-indi">
                                                    <span class="text-indi">90 days ago</span><span
                                                        class="line-indi"></span>
                                                    <span class="text-indi">Uptime</span><span class="line-indi"></span>
                                                    <span class="text-indi">Today </span>
                                                </div>

                                            </div>
                                        </div>


                                    </div>

                                </div>

                            </ng-template>
                        </ngb-panel>
                    </ngb-accordion>

                    <hr>

                </div>
                <div class="mt-5">
                    Contact us on <strong>0860 018 363 </strong> for any support issues.
                </div>



                <div id="tooltip"
                    style="display: none; position: absolute; z-index: 100; padding: 10px; background-color: white; border: 1px solid black;">
                    Tooltip content
                </div>
            </div>
        </div>
    </div>

    <script>



    </script>



</div>